import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './msalConfig';

// Single shared MSAL instance. `initialize()` must be awaited (in `index.tsx`)
// before React renders, otherwise the popup window's MSAL is not ready in time
// to post its auth response back to the opener — the opener then hits
// `monitor_window_timeout` and `loginPopup` silently fails.
export const msalInstance = new PublicClientApplication(msalConfig);
